import React, { createContext } from "react";
import { useConversation } from "../hooks/useConversation";
import { ConversationState } from "../types/ConversationState";
import { UserQuestionData, BotResponseData } from "../types/MessageData";

type ConversationContextProps = {
	conversationState: ConversationState;
	messages: (UserQuestionData | BotResponseData)[];
	clientId: string;
	serializedConversationHistory: string;
	addUserMessage: (message: string, topic?: string) => void;
	updateMessage: (message: (UserQuestionData | BotResponseData)) => void;
	resetConversation: () => void;
	testPhaseExpiredMode: boolean;
}
const initialContextValue: ConversationContextProps = {
	conversationState: 'idle',
	messages: [],
	clientId: '',
	serializedConversationHistory: '',
	testPhaseExpiredMode: true,
	addUserMessage: (__) => { },
	updateMessage: (__: (UserQuestionData | BotResponseData)) => {},
	resetConversation: () => { }
}
export const ConversationContext: React.Context<ConversationContextProps> = createContext<ConversationContextProps>(initialContextValue);

export const ConversationContextProvider = (props: { children: any }) => {
	const { state, clientId, messages, serializedConversationHistory, updateMessage, addUserMessage, resetConversation } = useConversation(initialContextValue.messages);

	const value: ConversationContextProps = {
		conversationState: state, messages, addUserMessage, resetConversation, serializedConversationHistory, updateMessage, clientId, testPhaseExpiredMode: new Date().getTime() > new Date(2025, 4, 29).getTime() && window.location.host.indexOf("ki.sg.ch") >= 0 && window.location.search.indexOf("bypassTestPhaseExpiredCheck") < 0
	};

	return (
		<ConversationContext.Provider value={value}>
			{props.children}
		</ConversationContext.Provider>
	);
};